import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import About from './pages/About';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';
import Tools from './pages/Tools';
import ToolDetails from './pages/ToolDetails'
import Contact from './pages/Contact';
import LandingPage from './pages/LandingPage'
import AnalysisPage from './pages/AnalysisPage'
import SocialPreviewPage from './pages/SocialPreviewPage'
import ScrollToTop from "./components/ScrollToTop";
function App() {
  return (
    <Router>
      <Layout>
      <ScrollToTop /> 
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/analyze" element={<AnalysisPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/tools/:slug" element={<ToolDetails />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/social-preview" element={<SocialPreviewPage />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;